<template>
  <vs-popup class="vs-con-loading__container user-edit-popup"
            id="popup"
            title="DOWNLOAD SALES ORDER OUTSTANDING REPORT"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(downloadReportDocument)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="countries" name="countries" rules="" v-slot="{ errors }">
                <small class="label">Country</small>
                <v-select :clearable="true" placeholder="Select Country" v-model="selectedCountry"
                          :options="countries"
                          label="name"
                          :reduce="option => option.value"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Download</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>

  </vs-popup>
</template>

<script>
import {RepositoryFactory} from "@/repository/RepositoryFactory";
const ReportingRepository = RepositoryFactory.get('reporting')
import Utils from "@/mixins/Utils";
import vSelect from 'vue-select'

export default {
  name: "DownloadSalesOrderOustandingReportPopUp",
  data () {
    return {
      open: false,
      endPoint: '',
      countries: [],
      selectedCountry: ''
    }
  },
  mixins:[Utils],
  components: {
    'v-select': vSelect,
  },
  methods:{
    openPopup(end_point, filters) {
      this.open = true
      this.endPoint = end_point
      this.countries = this.$store.getters.countries
      this.selectedCountry = filters.country ? filters.country: ''
    },
    async downloadReportDocument(){
      this.$vs.loading()
      try {
        const response = await ReportingRepository.downloadReportDocument(this.endPoint, `filter[country]=${this.selectedCountry}`)
        let fileURL = window.URL.createObjectURL(new Blob([response.data]));
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `Sales Order Delayed Report (${this.date}).xlsx`);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.open = false
      } catch (e) {

      }
      this.$vs.loading.close()
    }
  },
}
</script>

<style scoped>

</style>
